module.exports = __webpack_public_path__ + "media/help/aerobic-base-4c94df78.jpg";